<template>
  <select class="input" v-model="model">
    <option v-for="role in roleList"
      :key="role"
      :value="role"
      :disabled="disabled.includes(role)">
      {{role}}
    </option>
  </select>
</template>

<script>
export default {
  name: 'UserRole',
  props: [
    'value'
  ],
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('changeValue', value)
      }
    }
  },
  data () {
    return {
      roleList: [
        'admin',
        'manager',
        'staff',
        'guest'
      ],
      disabled: [
        'admin'
      ]
    }
  }
}
</script>
